/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type TradeDesignManagerModal_item$ref = any;
type TradeOnboardingCoachmarkConditionalLoader_item$ref = any;
export type PdpRespIconBubbleDesignManager_item$ref = any;
export type PdpRespIconBubbleDesignManager_item = {
    readonly " $fragmentRefs": TradeOnboardingCoachmarkConditionalLoader_item$ref & TradeDesignManagerModal_item$ref;
    readonly " $refType": PdpRespIconBubbleDesignManager_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespIconBubbleDesignManager_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TradeOnboardingCoachmarkConditionalLoader_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "TradeDesignManagerModal_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '6a6322d9f0824039950e04855d26b3d9';
export default node;
